export default {
	init () {
		// JavaScript to be fired on all pages
		require( '../components/modal' );
		require( '../components/nav' );
		require( '../components/headroom' );
		require( '../components/cookie' );
		require( '../components/filter' );
		require( '../components/dropdown' );
		require( '../components/picker' );
		require( '../components/video' );
		require( '../components/sidebar' );
        require( '../components/size-guide' );
		require( '../components/instagram' );
		require( '../components/newsletter' );
		require( '../components/unshippable' );
		require( '../components/alert' );
		require( '../components/category' );
		require( '../components/product-selected' );
		require( '../components/product' );
		require( '../components/cart' );
		require( '../components/language' );
		require( '../components/search' );
		require( '../components/checkout' );
		require( '../components/scroll' );
		require( '../components/backgroundSwitch' );
		require( '../components/articles' );
		require( '../components/language' );
		require( '../components/text-banner' );
		require( '../components/forms' );
		require( '../components/hero' );
		require( '../components/store-locator' );
		require( '../components/bullet-list' );
		require( '../components/bundles' );
		require( '../tracking/hotjar' );
		require( '../components/text-editor' );
		require( '../tracking/gtag' );
        require( '../components/top-banner' );
		require( '../components/article-nav' );
		require( '../components/image-slider' );
		require( '../components/triple-article-promo' );
	},
	finalize () {
		// JavaScript to be fired on all pages, after page specific JS is fired
		$( '.js-plus-item' ).plusItem();
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js